import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 传统纯 SCSS 样式（语义化类名）
import './assets/styles/main.scss'

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
